import { type ChatReducer } from "../types";

const findChannelInState = (state: ChatReducer, channelId: string) =>
  state.activeChannels.find((channel) => channel.id === channelId) ||
  state.channels.find((channel) => channel.id === channelId) ||
  state.unreadChannels.find((channel) => channel.id === channelId) ||
  state.archivedChannels.find((channel) => channel.id === channelId) ||
  null;

/**
 * Reads on a channel are broader than writes — a head coach sees every conversation, while every
 * write is gated by RLS on `assignedUsers` (`is_channel_member`). Without this check the update
 * affects 0 rows and PostgREST answers with PGRST116 instead of a permission error (TRE-1714).
 *
 * Channels missing from the store are treated as writable — the database stays the final authority.
 */
export const isAssignedToChannel = (state: ChatReducer, channelId: string, userId: string): boolean => {
  const channel = findChannelInState(state, channelId);

  return channel ? channel.assignedUsers.includes(userId) : true;
};
